import { useEffect } from "react";
import Navbar from "@/components/marketing/Navbar";
import Footer from "@/components/marketing/Footer";

const SECTIONS = [
  { h: "Account data", b: "We store your name, email, role, and workspace details to provide the service." },
  { h: "Workspace data", b: "Workspace settings such as country, currency, default costs, plan, and billing status." },
  { h: "Work entries", b: "AI impact entries you create, including hours, AI tool used, and assumptions." },
  { h: "Staff cost data", b: "Loaded hourly costs entered manually, by CSV, or by API. Access is restricted to authorized finance and admin roles." },
  { h: "Payments", b: "Subscription payments are handled by Stripe. We do not store full card details." },
  { h: "Analytics", b: "We record product events to improve the service and may use Google Analytics and a LinkedIn Insight Tag where configured." },
  { h: "CSV and API imports", b: "Data you import through CSV or the staff cost API is stored within your workspace and scoped to it." },
  { h: "Contact", b: "Questions about your data can be sent to support@netlift.app." },
];

export default function Privacy() {
  useEffect(() => { document.title = "Privacy Policy | NetLift"; }, []);
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="mx-auto max-w-3xl px-5 py-20 sm:px-8">
        <h1 className="font-heading text-4xl font-semibold tracking-tight text-slate-900">Privacy Policy</h1>
        <p className="mt-3 text-sm text-slate-500">How NetLift handles your data.</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h2 className="font-heading text-lg font-medium text-slate-900">{s.h}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.b}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
